import * as tslib_1 from "tslib";
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { scan, filter, observeOn } from 'rxjs/operators';
import { asyncScheduler } from 'rxjs';
import { ViewportScroller } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common";
var RestoreScrollService = /** @class */ (function () {
    function RestoreScrollService(router, viewportScroller) {
        this.router = router;
        this.viewportScroller = viewportScroller;
    }
    RestoreScrollService.prototype.watchAndRestore = function () {
        var _this = this;
        this.router.events.pipe(filter(function (ev) { return _this.isNavigationStart(ev) || _this.isNavigationEnd(ev); }), scan(function (acc, ev) { return _this.collect(acc, ev); }), filter(function (_a) {
            var event = _a.event, trigger = _a.trigger;
            return _this.isNavigationEndWithTrigger(event, trigger);
        }), observeOn(asyncScheduler)).subscribe(function (_a) {
            var trigger = _a.trigger, positions = _a.positions, idToRestore = _a.idToRestore;
            // if (trigger === 'imperative') this.scrollTo([0, 0]);
            if (trigger === 'popstate')
                _this.scrollTo(positions[idToRestore] || [0, 0]);
        });
    };
    RestoreScrollService.prototype.collect = function (acc, ev) {
        var _a;
        var collected = {
            event: ev,
            positions: tslib_1.__assign({}, acc.positions, (this.isNavigationStart(ev) ? (_a = {}, _a[ev.id] = this.getScrollTop(), _a) : {})),
            trigger: this.isNavigationStart(ev) ? ev.navigationTrigger : acc.trigger,
            idToRestore: this.getIdToRestore(ev) || acc.idToRestore
        };
        return collected;
    };
    RestoreScrollService.prototype.isNavigationStart = function (ev) {
        return ev instanceof NavigationStart;
    };
    RestoreScrollService.prototype.isNavigationEnd = function (ev) {
        return ev instanceof NavigationEnd;
    };
    RestoreScrollService.prototype.getScrollTop = function () {
        return this.viewportScroller.getScrollPosition();
    };
    RestoreScrollService.prototype.scrollTo = function (position) {
        this.viewportScroller.scrollToPosition(position);
    };
    RestoreScrollService.prototype.getIdToRestore = function (ev) {
        return this.isNavigationStart(ev) && ev.restoredState && ev.restoredState.navigationId + 1;
    };
    RestoreScrollService.prototype.isNavigationEndWithTrigger = function (event, trigger) {
        return this.isNavigationEnd(event) && !!trigger;
    };
    RestoreScrollService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RestoreScrollService_Factory() { return new RestoreScrollService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.ViewportScroller)); }, token: RestoreScrollService, providedIn: "root" });
    return RestoreScrollService;
}());
export { RestoreScrollService };
